export default function (dom, opts) {
  var options = {
    maxiSelector: '.overlay',
    openCls: 'overlay--show',
    htmlOpenCls: 'overlay-open',
    maxiInputSel: '.dc-input__field',

    buttonSel: '[data-trigger]',

    ...opts
  }

  const html = document.documentElement;
  const body = document.body;
  const buttonTrigger = dom.querySelector(options.buttonSel);
  const maxiDrop = body.querySelector(options.maxiSelector);


  init()

  function init() {
    buttonTrigger.addEventListener('click', openMaxiDrop)
  }

  function openMaxiDrop() {
    scrollToTop();
    html.classList.add(options.htmlOpenCls);
    maxiDrop.classList.add(options.openCls);
    setTimeout(() => {
      setFocus();
    }, 1000)

  }

  function scrollToTop() {
    html.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  function setFocus() {
    let maxiInput = body.querySelector(options.maxiInputSel);
    maxiInput.focus();
  }
}
